import { useQuery } from '@tanstack/react-query'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from '@omnea-app/legacy/utils/error-handling/throwifApiError'
import { RequestsHttpClient } from '@omnea-app/requests/requestsHttpClient'

export const useGetPauseReasons = () => {
  const { getToken } = useAuthenticatedUser()

  return useQuery({
    queryKey: ['pause-reasons'],
    queryFn: async () => {
      const apiClient = new RequestsHttpClient({ authorization: await getToken() })

      const { data, error } = await apiClient.GET('/pause-reasons')

      throwIfApiError(error)

      return data
    },
  })
}
